import { render, staticRenderFns } from "./qrtables.vue?vue&type=template&id=2275a206&"
import script from "./qrtables.vue?vue&type=script&lang=js&"
export * from "./qrtables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports